/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RedirectOAuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Redirect Oauth Exact Online
     * @param apiKey
     * @param code
     * @returns any Successful Response
     * @throws ApiError
     */
    public getFm3RedirectOauthExactOnline(
        apiKey: string,
        code: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/fm3/redirect_oauth/exactonline/{api_key}',
            path: {
                'api_key': apiKey,
            },
            query: {
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Redirect Oauth
     * @param slackLoginToken
     * @returns void
     * @throws ApiError
     */
    public getFm3RedirectOauth(
        slackLoginToken: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/fm3/redirect_oauth/oath2_redirect',
            query: {
                'slack_login_token': slackLoginToken,
            },
            errors: {
                307: `Successful Response`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Redirect Oauth Exact Online
     * @param apiKey
     * @param code
     * @returns any Successful Response
     * @throws ApiError
     */
    public getFm3RedirectOauthExactOnlineVLatest(
        apiKey: string,
        code: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/fm3/redirect_oauth/exactonline/{api_key}',
            path: {
                'api_key': apiKey,
            },
            query: {
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Redirect Oauth
     * @param slackLoginToken
     * @returns void
     * @throws ApiError
     */
    public getFm3RedirectOauthVLatest(
        slackLoginToken: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/fm3/redirect_oauth/oath2_redirect',
            query: {
                'slack_login_token': slackLoginToken,
            },
            errors: {
                307: `Successful Response`,
                422: `Validation Error`,
            },
        });
    }
}
